import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import { Select } from "antd";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import ScheduleFieldWrapper from "./ScheduleFieldWrapper";
import "./tiers.css"

const ScheduleTimezonePicker = ({
  shiftTimezone,
  label = "Timezone",
  required = false,
  placeholder = "Select timezone",
  onChange,
  disabled = false,
  value,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const timezoneOptions = useMemo(() => {
    if (!shiftTimezone) return [];
    return [
      {
        label: "Time zones",
        options: Object.entries(shiftTimezone).map(
          ([key, label]) => ({
            value: key,
            label: label,
          })
        ),
      },
    ];
  }, [shiftTimezone]);

  const handleOnChange = (selectedValue) => {
    onChange?.(selectedValue);
  };

  return (
    <ScheduleFieldWrapper label={label} required={required}>
      <div className="relative w-full flex select">
        <Select
          placeholder={placeholder}
          value={value}
          options={timezoneOptions}
          onChange={handleOnChange}
          disabled={disabled}
          overlayClassName="event-shift-options-single"
          style={{
            width: "100%",
            textTransform: "none",
            height: "22px",
          }}
          suffixIcon={null}
          onDropdownVisibleChange={(open) => setIsOpen(open)}
          filterOption={(inputValue, option) =>
            option?.label
              ?.toLowerCase()
              ?.includes(inputValue.toLowerCase())
          }
        />

        {isOpen ? (
          <CaretUpOutlined className="absolute right-2 top-1/2 -translate-y-1/2 text-btnDisableGray pointer-events-none" />
        ) : (
          <CaretDownOutlined className="absolute right-2 top-1/2 -translate-y-1/2 text-btnDisableGray pointer-events-none" />
        )}
      </div>
    </ScheduleFieldWrapper>
  );
};

const mapStateToProps = (state) => ({
  shiftTimezone: state.shifts.timezones,
});

export default connect(mapStateToProps)(ScheduleTimezonePicker);
